<template>
	<div class="faq-wrapper">
        <div class="column-history">
            <transition-group name="list" tag="ul" class="pl-0">
                <li
                    v-for="question in questionHistory"
                    :key="question.page.slug"
                    v-html="question.page.title"
                    :class="{ 'inactive': question != currentQuestion }"
                    class="question-title"
                    @click="selectQuestion(question, true)">
                </li>
            </transition-group>
        </div>
        <div class="column-answer">
            <transition name="scale">
                <div v-if="currentQuestion.page" :key="currentQuestion.page.slug" v-html="currentQuestion.page.text"></div>
            </transition>
        </div>
        <div class="column-questions" v-if="questions">
            <transition-group name="list" tag="ul" class="pl-0">
                <li
                    class="info-link"
                    v-for="question in questions"
                    :key="question.page.slug"
                    @click="selectQuestion(question)"
                >
                    <i class="fad fa-question-circle"></i>
                    <span>{{ question.page.title }}</span>
                </li>
            </transition-group>
        </div>
    </div>
</template>

<script>
import { LoadApiData } from '../modules/api';

const URL_PARAM_FAQ = "q";

export default {
	name: 'faq',
	data() {
		return {
			faqItems: null,
            currentQuestion: {},
            questionHistory: [],
            tempHistory: []
		};
	},
	methods: {
        selectQuestion(question, fromHistory, shouldUpdateUrl = true) {
            this.currentQuestion = question;

            if(fromHistory) {
                const questionIndex = this.questionHistory.indexOf(question);
                this.questionHistory = this.questionHistory.slice(0, questionIndex + 1);
            } else {
                this.questionHistory.push(question);
            }

			if (shouldUpdateUrl) this.updateUrl();
        },
        selectQuestionBySlug(slug, shouldUpdateUrl = true) {
            let question = this.findQuestionBySlug(slug, this.faqItems, shouldUpdateUrl);
            if(!question)
                return;

            this.questionHistory = this.tempHistory.reverse();
            this.currentQuestion = question;

			if (shouldUpdateUrl) this.updateUrl();
        },
        findQuestionBySlug(slug, array) {
            for (var item of array) {

                if (item.page.slug == slug) {
                    this.tempHistory.push(item);
                    return item;
                }
                else if (item.children && item.children.length > 0) {
                    let result = this.findQuestionBySlug(slug, item.children);
                    if (result) {
                        this.tempHistory.push(item);
                        return result;
                    }
                }
            }
            // return null if not found
            return null;
        },
        updateUrl() {
            let searchParams = new URLSearchParams(window.location.search);
            searchParams.set(URL_PARAM_FAQ, this.currentQuestion.page.slug);
            let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString() + location.hash;
            window.history.pushState( {path: newUrl} , '', newUrl);
        }
	},
    computed: {
        questions() {
            if(this.currentQuestion != null && this.currentQuestion.children)
                return this.currentQuestion.children;
            return this.faqItems;
        }
    },
	mounted() {
        const url = new URL(location.href);
        const requestedQuestion = url.searchParams.get(URL_PARAM_FAQ);

		LoadApiData(
            '/api/collections/faq/tree',
            ['slug', 'title', 'text'].join(','),
            '',
            (response) => {
                this.faqItems = response.data;

                if(requestedQuestion)
                    this.selectQuestionBySlug(requestedQuestion);
                else this.selectQuestion(this.faqItems[0], false, false);
            }
        );
	}
};
</script>
